// import { set, toggle } from '@/utils/vuex'

export default {
  namespaced: true,

  state: {
    links: [
      ['/', 'Home'],
      ['/about', 'About'],
      ['/contact', 'Contact Us'],
    ],
    drawer: null,
    language: null,
  },


  // actions: {
  //   setLanguage(context, payload) {
  //     context.commit('setLanguage', payload);
  //   },
  // },

  // mutations: {
  //   setDrawer: set('drawer'),
  //   toggleDrawer: toggle('drawer'),
  // },

  mutations: {
    language(state, value) {
      state.language = value
    },
    setDrawer(state, value) {
      state.drawer = value
    },
    toggleDrawer(state) {
      state.drawer = !state.drawer
    },
  },
}
